import type { SetTheme } from "./types";

const setTheme: SetTheme = (state, action) => {
  state.theme = action.payload;
};

export const reducers = {
  setTheme,
};
